import { EventScreenSection } from '../../core/EventScreenManager'
import { getCommonParams } from '../../utils/CommonParams'
import {
  BUSINESS_VERTICAL,
  BUTTON_NAME,
  BUTTON_TYPE,
} from '../../constants/EventHelper'
import {
  ButtonClickEvent,
  ButtonClickEventParams,
} from './CommonButtonClickedEvent'

export interface BcrsInfoButtonClickedEventParams extends ButtonClickEventParams {}

export async function trackBcrsInfoButtonClickEvent() {
  try {
    const commonProperties = getCommonParams()
    const params: BcrsInfoButtonClickedEventParams = {
      ...commonProperties,
    } as BcrsInfoButtonClickedEventParams
    params.BUTTON_NAME = BUTTON_NAME.INFO
    params.BUTTON_TYPE = BUTTON_TYPE.ICON_STYLE
    params.BUSINESS_VERTICAL = BUSINESS_VERTICAL.GROCERY
    params.EVENT_CATEGORY = 'grocery-online'
    params.SCREEN_SECTION = EventScreenSection.Widget(
      'beverage container deposit'
    )
    new ButtonClickEvent(params).track()
  } catch (error) {
    console.error('Error tracking BCRS info button click event:', error)
  }
}
